import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';


export const JoinNow = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section 
      className={`bg-gradient-to-br from-igbanwo-mint/90 to-igbanwo-mint rounded-2xl p-10 text-white text-center transition-all duration-1000 delay-400 transform ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <h2 className="text-3xl font-bold mb-4">Start Sharing Your Harvest Today</h2>
      <p className="max-w-2xl mx-auto mb-8 text-white/90">
        Join our growing community of home gardeners and food enthusiasts. Share your bounty and discover fresh, local produce.
      </p>
      <Link to="/auth?mode=register">
        <Button className="bg-white text-igbanwo-mint hover:bg-white/90">
          Join Igbanwo Now
        </Button>
      </Link>
    </section>
  );
};
